import { Modal, Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function ComingSoon({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}
      sx={{backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <Box
        component={motion.div}
        initial={{opacity:0,scale:0.85,y:20}}
        animate={{opacity:1,scale:1,y:0}}
        transition={{duration:0.3,ease:"easeOut"}}
        sx={{
          bgcolor:"white",borderRadius:4,
          boxShadow:"0 24px 64px rgba(0,0,0,0.16)",
          p:4,width:"90%",maxWidth:360,textAlign:"center",outline:"none",
        }}
      >
        <Box sx={{
          width:64,height:64,borderRadius:"50%",
          background:"linear-gradient(135deg,#f0fdf4,#dcfce7)",
          display:"flex",alignItems:"center",justifyContent:"center",
          mx:"auto",mb:2.5,border:"2px solid #bbf7d0",
        }}>
          <AccessTimeIcon sx={{fontSize:30,color:"#16a34a"}}/>
        </Box>
        <Typography sx={{fontSize:20,fontWeight:800,color:"#111827",mb:1}}>Coming Soon</Typography>
        <Typography sx={{fontSize:13,color:"#6b7280",lineHeight:1.7,mb:3}}>
          This feature is under development. We're working hard to bring it to you soon!
        </Typography>
        <Button variant="contained" fullWidth onClick={onClose}
          sx={{background:"linear-gradient(135deg,#16a34a,#22c55e)",borderRadius:2,fontWeight:600}}>
          Got It
        </Button>
      </Box>
    </Modal>
  );
}
